import React from 'react';
import {
  LinkFieldValue,
  ImageField,
  Image,
  Field,
  SitecoreContext,
  withSitecoreContext,
  WithSitecoreContextProps,
} from '@sitecore-jss/sitecore-jss-react';

type PageHeroProps = WithSitecoreContextProps & {
  fields: {
    'Desktop Image': ImageField;
    'Mobile Image': ImageField;
    'Tablet Image': ImageField;
    Link: Field<LinkFieldValue>;
  };
  sitecoreContext: SitecoreContext & { pageEditing: boolean };
};

const PageHero = ({ fields, sitecoreContext }: PageHeroProps): React.JSX.Element => {
  if (fields) {
    var ctaLink = fields.Link?.value;
    return (
      <div className="pagehero">
        {sitecoreContext.pageEditing && <p>PageHero Component Edit Mode</p>}
        {ctaLink?.href ? (
          <a href={ctaLink?.href} target={ctaLink?.target}>
            <Image className="heroImage" field={fields['Desktop Image']?.value} />
          </a>
        ) : (
          <Image className="heroImage" field={fields['Desktop Image']?.value} />
        )}
      </div>
    );
  } else if (!fields && sitecoreContext.pageEditing) {
    return <p>Please setup the Datasource.</p>;
  }
  return <></>;
};

export default withSitecoreContext()(PageHero);
